import { Rule, RuleAlias, RuleGroup } from "../entities";
import ActionManager from './ActionManager';
import { AUTH_RESOURCES } from './Resources';
const SECOND_APPROVAL_RULE = new Rule({
    alias: RuleAlias.SECOND_APPROVAL_CREATE,
    actionName: 'create',
    resourceToModify: AUTH_RESOURCES.SECOND_APPROVAL,
});
const actionManager = ActionManager.getReference();
actionManager.addAction(new Rule({ alias: RuleAlias.MANAGE_ALL, actionName: 'manage', resourceToModify: AUTH_RESOURCES.ALL }));
actionManager.addAction(new Rule({ alias: RuleAlias.READ_ALL, actionName: 'read', resourceToModify: AUTH_RESOURCES.ALL }));
actionManager.addAction(new Rule({ alias: RuleAlias.PROTOCOL_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.PROTOCOL }));
actionManager.addAction(new Rule({ alias: RuleAlias.PROTOCOL_UPDATE, actionName: 'update', resourceToModify: AUTH_RESOURCES.PROTOCOL }));
actionManager.addAction(new Rule({ alias: RuleAlias.PROTOCOL_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.PROTOCOL }));
actionManager.addAction(new Rule({ alias: RuleAlias.PROTOCOL_DELETE, actionName: 'delete', resourceToModify: AUTH_RESOURCES.PROTOCOL }));
actionManager.addAction(new Rule({ alias: RuleAlias.AUDIT_LOG_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.AUDIT_LOG }));
actionManager.addAction(new Rule({ alias: RuleAlias.USER_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.USER }));
actionManager.addAction(new Rule({ alias: RuleAlias.USER_UPDATE, actionName: 'update', resourceToModify: AUTH_RESOURCES.USER }));
actionManager.addAction(new Rule({ alias: RuleAlias.USER_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.USER }));
actionManager.addAction(new Rule({ alias: RuleAlias.CLIENT_DEVICE_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.CLIENT_DEVICE }));
actionManager.addAction(new Rule({
    alias: RuleAlias.CLIENT_DEVICE_DELETE,
    actionName: 'delete',
    resourceToModify: AUTH_RESOURCES.CLIENT_DEVICE,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.MANAGE_WIZARD, actionName: 'manage', resourceToModify: AUTH_RESOURCES.WIZARD }));
actionManager.addAction(new Rule({
    alias: RuleAlias.INSTALLATION_WIZARD_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.INSTALLATION_WIZARD,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.EQUIPMENT_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.EQUIPMENT }));
actionManager.addAction(new Rule({ alias: RuleAlias.EQUIPMENT_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.EQUIPMENT }));
actionManager.addAction(new Rule({ alias: RuleAlias.EQUIPMENT_UPDATE, actionName: 'update', resourceToModify: AUTH_RESOURCES.EQUIPMENT }));
actionManager.addAction(new Rule({ alias: RuleAlias.EQUIPMENT_DELETE, actionName: 'delete', resourceToModify: AUTH_RESOURCES.EQUIPMENT }));
actionManager.addAction(new Rule({ alias: RuleAlias.APPROVAL_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.APPROVAL }));
actionManager.addAction(new Rule({
    alias: RuleAlias.FIRST_APPROVAL_CREATE,
    actionName: 'create',
    resourceToModify: AUTH_RESOURCES.FIRST_APPROVAL,
}));
actionManager.addAction(SECOND_APPROVAL_RULE);
actionManager.addAction(new Rule({
    alias: RuleAlias.SYSTEM_UPDATE_CREATE,
    actionName: 'create',
    resourceToModify: AUTH_RESOURCES.SYSTEM_UPDATE,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.LICENSE_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.LICENSE }));
actionManager.addAction(new Rule({ alias: RuleAlias.BACKUP_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.BACKUP }));
actionManager.addAction(new Rule({ alias: RuleAlias.BACKUP_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.BACKUP }));
actionManager.addAction(new Rule({ alias: RuleAlias.LOGS_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.LOGS }));
actionManager.addAction(new Rule({ alias: RuleAlias.CREW_LIST_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.CREW_LIST }));
actionManager.addAction(new Rule({ alias: RuleAlias.CREW_LIST_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.CREW_LIST }));
actionManager.addAction(new Rule({ alias: RuleAlias.CREW_LIST_UPDATE, actionName: 'update', resourceToModify: AUTH_RESOURCES.CREW_LIST }));
actionManager.addAction(new Rule({ alias: RuleAlias.CREW_LIST_DELETE, actionName: 'delete', resourceToModify: AUTH_RESOURCES.CREW_LIST }));
actionManager.addAction(new Rule({
    alias: RuleAlias.RESPONSIBILITY_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.RESPONSIBILITY,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.RESPONSIBILITY_CREATE,
    actionName: 'create',
    resourceToModify: AUTH_RESOURCES.RESPONSIBILITY,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.RESPONSIBILITY_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.RESPONSIBILITY,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.RESPONSIBILITY_DELETE,
    actionName: 'delete',
    resourceToModify: AUTH_RESOURCES.RESPONSIBILITY,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.SHIP_NETWORK_SETTINGS_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.SHIP_NETWORK_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.SHIP_NETWORK_SETTINGS_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.SHIP_NETWORK_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.LWE_NETWORK_SETTINGS_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.LWE_NETWORK_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.LWE_NETWORK_SETTINGS_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.LWE_NETWORK_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.AIS_SETTINGS_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.AIS_SETTINGS,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.AIS_SETTINGS_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.AIS_SETTINGS }));
actionManager.addAction(new Rule({
    alias: RuleAlias.AUTOMATED_RECORDING_SETTINGS_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.AUTOMATED_RECORDING_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.AUTOMATED_RECORDING_SETTINGS_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.AUTOMATED_RECORDING_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.SYSTEM_TIME_SETTINGS_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.SYSTEM_TIME_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.SYSTEM_TIME_SETTINGS_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.SYSTEM_TIME_SETTINGS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.RESET_CLOUD_CONNECTION_CREATE,
    actionName: 'create',
    resourceToModify: AUTH_RESOURCES.RESET_CLOUD_CONNECTION,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.SELF_CHECK_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.SELF_CHECK }));
actionManager.addAction(new RuleGroup(RuleAlias.SYSTEM_SETTINGS_READ, 'read', AUTH_RESOURCES.SYSTEM_SETTINGS, [
    actionManager.getAction(RuleAlias.SHIP_NETWORK_SETTINGS_READ),
    actionManager.getAction(RuleAlias.LWE_NETWORK_SETTINGS_READ),
    actionManager.getAction(RuleAlias.AIS_SETTINGS_READ),
    actionManager.getAction(RuleAlias.AUTOMATED_RECORDING_SETTINGS_READ),
    actionManager.getAction(RuleAlias.SYSTEM_TIME_SETTINGS_READ),
    actionManager.getAction(RuleAlias.RESET_CLOUD_CONNECTION_CREATE),
    actionManager.getAction(RuleAlias.SELF_CHECK_READ),
]));
actionManager.addAction(new Rule({ alias: RuleAlias.VOYAGES_UPDATE, actionName: 'update', resourceToModify: AUTH_RESOURCES.VOYAGE }));
actionManager.addAction(new Rule({ alias: RuleAlias.VOYAGES_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.VOYAGE }));
actionManager.addAction(new Rule({ alias: RuleAlias.VOYAGES_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.VOYAGE }));
actionManager.addAction(new Rule({
    alias: RuleAlias.VESSEL_PARTICULARS_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.VESSEL_PARTICULARS,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.VESSEL_PARTICULARS_READ,
    actionName: 'read',
    resourceToModify: AUTH_RESOURCES.VESSEL_PARTICULARS,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.ORDER_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.ORDER }));
actionManager.addAction(new Rule({ alias: RuleAlias.ORDER_CREATE, actionName: 'create', resourceToModify: AUTH_RESOURCES.ORDER }));
actionManager.addAction(new Rule({ alias: RuleAlias.ORDER_UPDATE, actionName: 'update', resourceToModify: AUTH_RESOURCES.ORDER }));
actionManager.addAction(new Rule({
    alias: RuleAlias.SOUNDING_SPOT_UPDATE,
    actionName: 'update',
    resourceToModify: AUTH_RESOURCES.SOUNDING_SPOT,
}));
actionManager.addAction(new Rule({ alias: RuleAlias.SOUNDING_SPOT_READ, actionName: 'read', resourceToModify: AUTH_RESOURCES.SOUNDING_SPOT }));
actionManager.addAction(new Rule({
    alias: RuleAlias.SOUNDING_SPOT_CREATE,
    actionName: 'create',
    resourceToModify: AUTH_RESOURCES.SOUNDING_SPOT,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.SOUNDING_SPOT_DELETE,
    actionName: 'delete',
    resourceToModify: AUTH_RESOURCES.SOUNDING_SPOT,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.MANAGE_BOOK_CONFIGURATION,
    actionName: 'manage',
    resourceToModify: AUTH_RESOURCES.BOOK_CONFIGURATION,
}));
actionManager.addAction(new Rule({
    alias: RuleAlias.MANAGE_CHECKLIST_TYPE,
    actionName: 'manage',
    resourceToModify: AUTH_RESOURCES.CHECKLIST_TYPE,
}));
const OPERATOR_RULES = [
    actionManager.getAction(RuleAlias.PROTOCOL_READ),
    actionManager.getAction(RuleAlias.PROTOCOL_CREATE),
    actionManager.getAction(RuleAlias.PROTOCOL_UPDATE),
    actionManager.getAction(RuleAlias.PROTOCOL_DELETE),
    actionManager.getAction(RuleAlias.RESPONSIBILITY_CREATE),
    actionManager.getAction(RuleAlias.RESPONSIBILITY_DELETE),
    actionManager.getAction(RuleAlias.RESPONSIBILITY_READ),
    actionManager.getAction(RuleAlias.RESPONSIBILITY_UPDATE),
    actionManager.getAction(RuleAlias.APPROVAL_READ),
    actionManager.getAction(RuleAlias.BACKUP_READ),
    actionManager.getAction(RuleAlias.LOGS_READ),
    actionManager.getAction(RuleAlias.CREW_LIST_CREATE),
    actionManager.getAction(RuleAlias.CREW_LIST_UPDATE),
    actionManager.getAction(RuleAlias.CREW_LIST_DELETE),
    actionManager.getAction(RuleAlias.CREW_LIST_READ),
    actionManager.getAction(RuleAlias.VESSEL_PARTICULARS_READ),
    actionManager.getAction(RuleAlias.VESSEL_PARTICULARS_UPDATE),
    actionManager.getAction(RuleAlias.VOYAGES_CREATE),
    actionManager.getAction(RuleAlias.VOYAGES_READ),
    actionManager.getAction(RuleAlias.VOYAGES_UPDATE),
    actionManager.getAction(RuleAlias.CLIENT_DEVICE_DELETE),
    actionManager.getAction(RuleAlias.CLIENT_DEVICE_READ),
    actionManager.getAction(RuleAlias.SHIP_NETWORK_SETTINGS_READ),
    actionManager.getAction(RuleAlias.SHIP_NETWORK_SETTINGS_UPDATE),
    actionManager.getAction(RuleAlias.LWE_NETWORK_SETTINGS_READ),
    actionManager.getAction(RuleAlias.LWE_NETWORK_SETTINGS_UPDATE),
    actionManager.getAction(RuleAlias.AIS_SETTINGS_READ),
    actionManager.getAction(RuleAlias.AIS_SETTINGS_UPDATE),
    actionManager.getAction(RuleAlias.AUTOMATED_RECORDING_SETTINGS_READ),
    actionManager.getAction(RuleAlias.AUTOMATED_RECORDING_SETTINGS_UPDATE),
    actionManager.getAction(RuleAlias.SYSTEM_TIME_SETTINGS_READ),
    actionManager.getAction(RuleAlias.SYSTEM_TIME_SETTINGS_UPDATE),
    actionManager.getAction(RuleAlias.SELF_CHECK_READ),
    actionManager.getAction(RuleAlias.ORDER_READ),
    actionManager.getAction(RuleAlias.ORDER_CREATE),
    actionManager.getAction(RuleAlias.ORDER_UPDATE),
    actionManager.getAction(RuleAlias.SOUNDING_SPOT_READ),
    actionManager.getAction(RuleAlias.INSTALLATION_WIZARD_READ),
];
export { ActionManager, AUTH_RESOURCES, OPERATOR_RULES, SECOND_APPROVAL_RULE };
//# sourceMappingURL=index.js.map